var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPorchDeck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 101,
    viewBox: "0 0 143 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2691 3.70361H3.70227V62.2036H139.298V3.70361H120.648V45.7129H22.2691V3.70361Z",
    stroke: "#333333",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3929 62.2036V97.2962H18.1689V62.2036",
    stroke: "#333333",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.739 62.2036V97.2962H105.515V62.2036",
    stroke: "#333333",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3804 62.2036V67.5647V75.4073V82.6851V90.5277V97.2962H49.7122V90.5277V82.6851V75.4073V67.5647V62.2036",
    stroke: "#333333",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3804 73.7222H49.7122",
    stroke: "#333333",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3804 85.2964H49.7122",
    stroke: "#333333",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 101,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorchDeck);
export default __webpack_public_path__ + "static/media/porch_deck.2d78c06cbb4d6d94d6d679fab1fd1370.svg";
export { ForwardRef as ReactComponent };